<template>
  <div class="dashboard-panel">
      <portal target-el="#filter">
        <PrimaryFilter
          :menuOptions="menuList"
          :selectedCategory="selectedCategory"
          :buttonsList="buttonsList"
          :hideSearchPopup="true"
          @createWorkflow="openDetails"
        />
      </portal>
      <div class="d-flex" style="justify-content: end;">
      </div>
      <div>
        <MdmHeader
          :headers="sectionHeaders"
          :hasColumnPicker="true"
          :noCheckbox="true"
          :maxDisplayColumn="maxDisplayColumn"
        />
        <div v-if="isLoading" class="paymentloader"></div>
        <div v-else-if="workflowList.length === 0" class="emptydiv">
          <div class="paymentempty"></div>
          <div class="emptytext">{{$t('MDM_NO_DATA_FOUND')}}</div>
        </div>
        <MdmRow
          v-else
          v-for="(workflow, index) in workflowList"
          :key="index"
          :data="workflow"
          :headers="sectionHeaders"
          :showDetails="showDetails"
          @details="openDetails(workflow.id)"
        />
      </div>
  </div>
  </template>

<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';
import { menuList } from '@/constants/shipment-workflow';
import EventSelection from './eventSelection.vue';
import ShipmentDetails from './shipmentDetails.vue';
import HeadPanel from '@common/components/HeadPanel';
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';


export default {
  components: {
    HeadPanel,
    PrimaryFilter,
    EventSelection,
    ShipmentDetails,
    MdmHeader,
    MdmRow,
  },

  data() {
    return {
      menuList,
      indentList: [],
      metricsCountLoading: false,
      steps: ['Basic Info', 'Details', 'Overview'],
      currentStep: 0,
      workFlow: {},
      workflowList: [],
      sectionHeaders: [
        { id: 0, title: 'Movement Type', column: 'movement_type', tlabel: 'MDM_MOVEMENT_TYPE', truncateOn: 30, show: true, colSpan: 4 },
        { id: 1, title: 'Delivery Type', column: 'delivery_type', tlabel: 'INDENT_DELIVERY_TYPE', truncateOn: 30, show: true, colSpan: 4 },
        { id: 2, title: 'No. Of Events', column: 'number_of_events', tlabel: 'NO_OF_EVENTS', show: true, colSpan: 4 },
      ],
    };
  },
  computed: {
    selectedCategory() {
      const path = this.$router.history.current.name;
      return this.menuList.find(menu => menu.id === path);
    },
    showDetails() {
      // return this.$hasPermission('update_shipment_workflow');
      return true;
    },
    buttonsList() {
      return [{
        id: 'add',
        name: 'Add',
        show: true,
        class: 'header_pbtn',
        disabled: false,
        emitMethod: 'createWorkflow',
        permission: 'update_shipment_workflow',
      }];
    },
  },
  async created() {
    await this.getWorkflows();
  },
  methods: {
    moveToNextStep(data) {
      if (this.currentStep === 0) {
        this.workFlow = {
          ...this.workFlow,
          movement_type: data.movement_type,
          delivery_type: data.delivery_type,
        };
      } else if (this.currentStep === 1) {
        this.workFlow = {
          ...this.workFlow,
          events: data.events,
        };
      }
      this.currentStep = this.currentStep + 1;
    },
    async getWorkflows() {
      const result = await this.$store.dispatch(
        'app/getWorkflowsList',
      );
      if (result && result.data && result.data.length) {
        this.workflowList = result.data;
      }
    },
    async openDetails(workFlowId) {
      this.$router.push({ name: 'ShipmentWorkflowDetails', params: { id: workFlowId || 'create' } });
    },
  },
};
</script>

<style scoped>

.steps {
  display: flex;
  flex-direction: column;
}

.step {
  padding: 10px;
  margin-bottom: 10px;
  position: relative;
  transition: all 0.3s;
}

.step-number {
  width: 24px;
  height: 24px;
  background: #ccc;
  color: #fff;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  line-height: 24px;
  margin-right: 8px;
}

.step-title {
  display: inline-block;
}

.step-active .step-number {
  background: linear-gradient(0deg, rgba(0, 118, 221, 0.1), rgba(0, 118, 221, 0.1)) !important;
  color: black;
  border-color: black;
}

.step.completed .step-number {
  background: rgb(31, 205, 147) !important;
  color: white;
}

.form-content {
  flex: 1;
  padding-left: 20px;
}

.navigation-buttons {
  margin-top: 20px;
}
</style>

